"use client"

import { useRef, useEffect } from "react"

export function ReadingProgressBar() {
  const barRef = useRef<HTMLDivElement>(null)
  const rafRef = useRef<number>(0)

  useEffect(() => {
    const update = () => {
      const scrollable =
        document.documentElement.scrollHeight - window.innerHeight
      if (scrollable > 0 && barRef.current) {
        const pct = Math.min((window.scrollY / scrollable) * 100, 100)
        barRef.current.style.width = `${pct}%`
      }
    }

    const onScroll = () => {
      cancelAnimationFrame(rafRef.current)
      rafRef.current = requestAnimationFrame(update)
    }

    window.addEventListener("scroll", onScroll, { passive: true })
    update()
    return () => {
      window.removeEventListener("scroll", onScroll)
      cancelAnimationFrame(rafRef.current)
    }
  }, [])

  return (
    <div
      className="fixed left-0 top-0 z-[60] h-1 w-full"
      role="progressbar"
      aria-label="Reading progress"
    >
      <div
        ref={barRef}
        className="h-full w-0 bg-[#1d7df2]"
        style={{ transition: "width 150ms cubic-bezier(0.4, 0, 0.2, 1)" }}
      />
    </div>
  )
}
